<template>
  <div>
    <div>
      <br>
      <div class="normalCenterAlign">C O N F I D E N T I A L</div>
    </div>
    <br>
    <br>
    <br>
      <div class="normalCenterAlign">HEADQUARTERS</div>
      <div class="normalCenterAlign">370TH / 48TH FIGHTER GROUP</div>
      <div class="normalCenterAlign">A.P.O. 637 U.S. ARMY</div>
    <br>
    <hr style="font-family: 'Remingtoned Type'">
    <br>
      <div class="normalCenterAlign">Pilot's Personal Combat Report</div>
      <div class="normalCenterAlign">IX Fighter Command F.O. 278</div>
    <br>
    <hr style="font-family: 'Remingtoned Type'">
    <br>
    <div>
      <span class="normalCenter">A. Combat</span>
      <br>
      <br>
      <span title="This is the pre-selected date the mission took place." class="normalCenter">B. {{ decodeHTML(report_info.mission_hist_date) }}</span>
      <br>
      <br>
      <div class="normalCenter">
        <span title="Here you fill in the Flight you flew in for that mission and your Squadron (is usually pre-selected). Your squadron code is also pre-selected.">
         C. <select v-model="report_flight">
            <option
              v-for="(flight, index) in flightStatus"
              v-bind:value="index"
            >
              {{flight}}
            </option>
          </select>,
          <select v-model="report_unit">
            <option
              v-for="d_unit in unitsByFaction(5)"
              v-bind:value="d_unit.depl_unit_id">
              {{ d_unit.hist_unit_name }}
            </option>
          </select>
          ({{ reportUnit.hist_unit_code }})
        </span>
        </div>
      <br>
      <span class="normalCenter">
        <span title="Here pilots inserted the time at which they made contact with the enemy and went 'Gung Ho!'.">
         D. <input v-model="report_time_attack_delivered">
        </span>
      </span>
      <br>
      <br>
      <span class="normalCenter">E.
        <span title="Pilots wrote here the location where their attack was delivered.">
          <input v-model="report_place_attack_delivered">
        </span>
      </span>
      <br>
      <br>
      <span class="normalCenter">F.
        <span title="This field is for reporting the altitude of enemy aircraft.">
          <input v-model="report_enemy_height">
        </span>
      </span>
      <br>
      <br>
      <span class="normalCenter">G.
        <span title="This field is for reporting the type of enemy aircraft.">
          <input v-model="report_type_enemy_ac">
        </span>
        <span title="This field is for reporting the number of enemy aircraft.">
          <select v-model="report_number_enemy_ac">
          <option
            v-for="(number_enemy_ac, index) in numberEnemyACStatus"
            v-bind:value="index">
            {{number_enemy_ac}}
          </option>
          </select>
          </span>
      </span>
      <br>
      <br>
      <span class="normalCenter">H.
        <span title="This field is for reporting casualties dealt to the enemy.">
          <input v-model="report_enemy_casualty">
        </span>
      </span>
      <br>
      <br>
      <span class="normalCenter">I. Narrative - - - - - </span>
    </div>
    <br>
    <div class="bigLeft">
      Report dated {{ decodeHTML(report_info.mission_hist_date) }}. If nothing follows this, it is assumed there was nothing to report.
    </div>
    <div>
      <textarea
        style="margin-left: 8%; height: 20em; width: 83%"
        placeholder="Synopsis (optional)"
        v-model="report_synopsis"
        title="This is where you type a synopsis of how the mission went from your perspective. This field is optional. Images can be included by using [img]image-url[/img]" class="textarea-style"></textarea>
    </div>
    <br>
    <br>
    <div class="bigRight clearfix">
      <!--Pilot signature and info-->
      <div class="float-right">
        <div class="bigSignature">
          {{ decodeHTML(report_info.first_name) }}
          {{ decodeHTML(report_info.last_name) }}
        </div>
        <div>
          {{ decodeHTML(report_info.first_name) }}
          '{{ report_info.callsign }}'
          {{ decodeHTML(report_info.last_name) }}
        </div>
        <div title="Here you must insert the Section and position you flew in during the mission. This field is mandatory.">
                <span>
                <select v-model="report_section">
                <option
                v-for="(section, index) in sectionStatus"
                v-bind:value="index"
                >
                {{section}}
                </option>
                </select>
                </span>
          /
          <span>
         <select v-model="report_section_pos">
          <option
            v-for="(section_pos, index) in sectionPosStatus"
            v-bind:value="index"
          >
            {{section_pos}}
          </option>
        </select>
      </span>
        </div>
        <span title="This is where you must indicate the aircraft you flew. This field is mandatory.">
              <span>
              <select v-model="report_aircraft">
               <option :value="null" disabled>Select aircraft</option>
               <option
                 v-for="aircraft in assetByFactionControllable(5, 1)"
                 v-bind:value="aircraft.id"
                 >
                 {{ aircraft.name }}
               </option>
               </select>
               </span>
          </span>
          ,
          <span title="Here you must indicate your aircraft's code letter. Please use capital letters. This field is mandatory.">
              <span>
              <input
              placeholder="Markings"
              v-model="report_markings"
              >
              </span>
          </span>
        </div>
        <div>
          {{ decodeHTML(report_info.abreviation) }}, U.S.A.A.F.
        </div>
      </div>
    <br><br><br><br><br><br><br><br><br><br>
    <div title="Here you must indicate your base from which you took off. This field is mandatory.">
        <span style="font-size: large;margin-left: 25%">
        U.S.A.A.F. Airbase
        <input
          placeholder="Airfield"
          v-model="report_aerodrome"
          >
        </span>
    </div>
  </div>

</template>

<script>
import stringConv from "../../resource/stringConverter"
import statConv from "../../resource/statusConverter"
import EditClaimUSAAF from "./EditClaimUSAAF"
import EditClaimGround from "./EditClaimGround"
import { mapState, mapGetters } from "vuex"

export default {
  name: "EditReportUSAAF",
  components: {
    EditClaimUSAAF,
    EditClaimGround,
    Comment
  },
  mixins: [
    stringConv,
    statConv
  ],
  props: {
    first_name: {
      type: String,
      default: null
    },
    last_name: {
      type: String,
      default: null
    },
    callsign: {
      type: String,
      default: null
    },
    rank_name: {
      type: String,
      default: null
    },
  },
  computed: {

    report_unit: {
      get () {
        return this.report_info.depl_unit_id;
      },
      set (value) {
        this.$store.commit('missionStore/updateReportValue',
          {
            array_name: "report",
            update_column_name: "depl_unit_id",
            update_column_value: value
          });
      }
    },

    report_flight: {
      get () {
        var flight = this.report_details.flight;
        return flight === undefined ? 2 : flight;
      },
      set (value) {
        this.$store.commit('missionStore/updateReportValue',
          {
            array_name: "report_details",
            update_column_name: "flight",
            update_column_value: value
          });
      }
    },

    report_section: {
      get () {
        var section = this.report_details.section;
        return section === undefined ? 8 : section;
      },
      set (value) {
        this.$store.commit('missionStore/updateReportValue',
          {
            array_name: "report_details",
            update_column_name: "section",
            update_column_value: value
          });
      }
    },

    report_section_pos: {
      get () {
        var section_pos = this.report_details.section_pos;
        return section_pos === undefined ? 5 : section_pos;
      },
      set (value) {
        this.$store.commit('missionStore/updateReportValue',
          {
            array_name: "report_details",
            update_column_name: "section_pos",
            update_column_value: value
          });
      }
    },

    report_aerodrome: {
      get () {
        return this.report_info.base;
      },
      set (value) {
        this.$store.commit('missionStore/updateReportValue',
          {
            array_name: "report",
            update_column_name: "base",
            update_column_value: value
          });
      }
    },


    report_number_enemy_ac: {
      get () {
        var number_enemy_ac = this.report_details.number_enemy_ac;
        return number_enemy_ac === undefined ? 0 : number_enemy_ac;
      },
      set (value) {
        this.$store.commit('missionStore/updateReportValue',
          {
            array_name: "report_details",
            update_column_name: "number_enemy_ac",
            update_column_value: value
          });
      }
    },


    report_type_enemy_ac: {
      get () {
        return this.report_details.type_enemy_ac;
      },
      set (value) {
        this.$store.commit('missionStore/updateReportValue',
          {
            array_name: "report_details",
            update_column_name: "type_enemy_ac",
            update_column_value: value
          });
      }
    },

    report_time_attack_delivered: {
      get () {
        return this.report_details.time_attack_delivered;
      },
      set (value) {
        this.$store.commit('missionStore/updateReportValue',
          {
            array_name: "report_details",
            update_column_name: "time_attack_delivered",
            update_column_value: value
          });
      }
    },

    report_place_attack_delivered: {
      get () {
        return this.report_details.place_attack_delivered;
      },
      set (value) {
        this.$store.commit('missionStore/updateReportValue',
          {
            array_name: "report_details",
            update_column_name: "place_attack_delivered",
            update_column_value: value
          });
      }
    },

    report_enemy_height: {
      get () {
        return this.report_details.enemy_height;
      },
      set (value) {
        this.$store.commit('missionStore/updateReportValue',
          {
            array_name: "report_details",
            update_column_name: "enemy_height",
            update_column_value: value
          });
      }
    },

    report_enemy_casualty: {
      get () {
        return this.report_details.enemy_casualty;
      },
      set (value) {
        this.$store.commit('missionStore/updateReportValue',
          {
            array_name: "report_details",
            update_column_name: "enemy_casualty",
            update_column_value: value
          });
      }
    },

    report_our_casualty_ac: {
      get () {
        return this.report_details.our_casualty_ac;
      },
      set (value) {
        this.$store.commit('missionStore/updateReportValue',
          {
            array_name: "report_details",
            update_column_name: "our_casualty_ac",
            update_column_value: value
          });
      }
    },

    report_our_casualty_personnel: {
      get () {
        return this.report_details.our_casualty_personnel;
      },
      set (value) {
        this.$store.commit('missionStore/updateReportValue',
          {
            array_name: "report_details",
            update_column_name: "our_casualty_personnel",
            update_column_value: value
          });
      }
    },

    report_aircraft: {
      get () {
        return this.report_info.asset_id;
      },
      set (value) {
        this.$store.commit('missionStore/updateReportValue',
          {
            array_name: "report",
            update_column_name: "asset_id",
            update_column_value: value
          });
      }
    },

    report_markings: {
      get () {
        return this.report_info.markings;
      },
      set (value) {
        this.$store.commit('missionStore/updateReportValue',
          {
            array_name: "report",
            update_column_name: "markings",
            update_column_value: value
          });
      }
    },

    report_serial_no: {
      get () {
        return this.report_details.serial_no;
      },
      set (value) {
        this.$store.commit('missionStore/updateReportValue',
          {
            array_name: "report_details",
            update_column_name: "serial_no",
            update_column_value: value
          });
      }
    },

    report_pilot_status: {
      get () {
        var pilot_status = this.report_info.pilot_status;
        return pilot_status === undefined ? 0 : pilot_status;
      },
      set (value) {
        this.$store.commit('missionStore/updateReportValue',
          {
            array_name: "report",
            update_column_name: "pilot_status",
            update_column_value: value
          });
      }
    },

    report_asset_status: {
      get () {
        var asset_status = this.report_info.asset_status;
        return asset_status === undefined ? 0 : asset_status;
      },
      set (value) {
        this.$store.commit('missionStore/updateReportValue',
          {
            array_name: "report",
            update_column_name: "asset_status",
            update_column_value: value
          });
      }
    },

    report_synopsis: {
      get () {
        return this.report_info.synopsis;
      },
      set (value) {
        this.$store.commit('missionStore/updateReportValue',
          {
            array_name: "report",
            update_column_name: "synopsis",
            update_column_value: value
          });
      }
    },

    ...mapState("missionStore", {
      report_info: state => state.report,
      report_details: state => state.report_details,
      aerial_claims: state => state.aerial_claims,
      ground_claims: state => state.ground_claims
    }),

    ...mapGetters("missionStore", [
      "reportUnit",
      "unitsByFaction",
      "assetByFactionControllable"
    ])
  },
  methods: {

    addAerialClaim: function () {

      this.$store.commit('missionStore/addAerialClaim',
        {
          report_id: this.report_info.report_id,
          asset_id: null,
          enemy_status: 0,
          shared: 0
        });
    },

    addGroundClaim: function () {

      this.$store.commit('missionStore/addGroundClaim',
        {
          report_id: this.report_info.report_id,
          asset_id: null,
          amount: 1,
          description: null
        });
    }
  }
}
</script>

<style scoped>

  .rTable {
    display: table;
    margin-left: 8%;
    margin-right: 0%;
    width: 92%;
  }
  .rTableRow {
    display: table-row;
  }
  .rTableCellLeft {
    display: table-cell;
    font-size: large;
    padding-top: 0.5%;
    width: 52%;
    padding-bottom: 0.5%;
    /* border: 1px solid #999999;*/
  }

  .rTableCellLetter {
    display: table-cell;
    font-size: large;
    padding-top: 0.48%;
    padding-bottom: 0.48%;
    width: 3%;
    /*border: 1px solid #999999;*/
  }

  .rTableCellRight {
    display: table-cell;
    font-size: large;
    padding-top: 0.48%;
    padding-bottom: 1.2%;
    width: 30%;
    /*border: 1px solid #999999;*/
  }

  .rTableCellTop {
    display: table-cell;
    font-size: large;
    padding-top: 0.8%;
    padding-bottom: 0.8%;
    /*border: 1px solid #999999;*/
  }

  .rTableCellCenter {
    display: table-cell;
    font-size: large;
    padding-top: 0.48%;
    padding-bottom: 0.48%;
    width: 15%;
    /*border: 1px solid #999999;*/
  }

  .bigRight {
    float: right;
    font-size: large;
    margin-right: 8%;
  }

  .bigLeft {
    font-size: large;
    margin-left: 8%;
  }

  .biggerCenter {
    font-size: x-large;
    text-decoration: underline;
    margin-left: 40%;
  }

  .normalCenter {
    margin-left: 40%;
    font-size: large;
  }

  .normalCenterAlign {
    font-size: large;
    text-align: center;
  }

  /* Tooltip container */
  .tooltip {
    position: relative;
    display: inline-block;
  }

  /* Tooltip text */
  .tooltip .tooltiptext {
    visibility: hidden;
    width: 120px;
    background-color: #1a1a1a;
    color: #d6d6d6;
    text-align: center;
    top: -5px;
    left: 105%;
    padding: 10px 5px;
    border-radius: 6px;

    /* Position the tooltip text - see examples below! */
    position: absolute;
    z-index: 1;
  }

  /* Show the tooltip text when you mouse over the tooltip container */
  .tooltip:hover .tooltiptext {
    visibility: visible;
  }

</style>



// WEBPACK FOOTER //
// src/components/campaign/EditReportUSAAF.vue